<input [id]="cyId" [ngModel]="searchText" (ngModelChange)="onSearchChange($event)" type="text" class="form-control" [placeholder]="placeholder">